import { Icon } from '~/components/atomic';
import * as S from './Card.styled';

interface CardProps {
  id: string;
  name: string;
  image: string;
  type: 'Edit' | 'Liked';
  onClick: (id: string) => void;
  onIconClick?: (id: string) => void;
}

export default function Card({
  id,
  name,
  image,
  type,
  onClick,
  onIconClick,
}: CardProps) {
  return (
    <S.Container onClick={() => onClick(id)}>
      <S.ImageBox>
        <img src={image} alt='character thumbnail' />
      </S.ImageBox>
      <S.NameBox>
        <S.Name>{name}</S.Name>
      </S.NameBox>

      {type === 'Edit' ? (
        <S.ButtonBox
          onClick={(e) => {
            e.stopPropagation();
            onIconClick?.(id);
          }}
        >
          <S.IconBackWrapper>
            <Icon size={22} color='content_light_1' iconName='Edit' />
          </S.IconBackWrapper>
        </S.ButtonBox>
      ) : (
        <S.ButtonBox
          onClick={(e) => {
            e.stopPropagation();
            onIconClick?.(id);
          }}
        >
          <Icon size={28} iconName='Favorite' />
        </S.ButtonBox>
      )}
    </S.Container>
  );
}
